export const environment = {
  production: false,
  supabaseConfig: {
    ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp1aHB5eWh3emdpcGl3b25pbHV2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA3MTA0MTYsImV4cCI6MjA4NjI4NjQxNn0.qlfKVxtiPeNCUMZtBgTs1eP7n4A1KeDRf25feX1B1KM",
    SUPABASE_PUBLIC_URL: "https://zuhpyyhwzgipiwoniluv.supabase.co",
    IS_PROD_API: false,
  },
};
